import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { ButtonTerBox } from './ButtonTerciary.style';

type TButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
  typeSubmit: boolean;
  textToolTip?: string;
};
const ButtonTerciary: React.FC<TButtonProps> = ({ onClick, disabled = false, label, typeSubmit, textToolTip = '' }) => {
  return (
    <>
      {typeSubmit ? (
        <Tooltip title={textToolTip} arrow>
          <ButtonTerBox type="submit" disabled={disabled} onClick={onClick}>
            {label}
          </ButtonTerBox>
        </Tooltip>
      ) : (
        <Tooltip title={textToolTip} arrow>
          <ButtonTerBox disabled={disabled} onClick={onClick}>
            {label}
          </ButtonTerBox>
        </Tooltip>
      )}
    </>
  );
};

export default ButtonTerciary;
